import React, { useMemo } from 'react';
import { useBoardChartData } from '../../hooks/useBoardChartData';
import { BaseChartProps } from './types';
import { CHART_COLORS, getCurrencySymbol, formatCompactNumber } from './chartTheme';
import { useSetChartMetadata } from './ChartContext';

export const AdSpendKPIChart: React.FC<BaseChartProps> = () => {
    const { finance, currencySettings } = useBoardChartData();

    const currencySymbol = useMemo(
        () => getCurrencySymbol(currencySettings?.default),
        [currencySettings?.default]
    );

    const adSpend = useMemo(
        () => finance?.metrics?.adSpend ?? 0,
        [finance?.metrics?.adSpend]
    );

    const isEmpty = useMemo(() => !finance || adSpend === 0, [finance, adSpend]);

    useSetChartMetadata({ isEmpty });

    return (
        <div className="flex h-full w-full items-center justify-center [container-type:inline-size]">
            <p
                className="font-semibold text-center"
                style={{
                    color: CHART_COLORS.chart.line5,
                    fontSize: 'clamp(1.25rem, 8cqi, 2.5rem)',
                }}
            >
                {formatCompactNumber(adSpend, currencySymbol)}
            </p>
        </div>
    );
};
